import React, { Component } from "react";
import { Form, AutoComplete, Input, Spin, Checkbox } from "antd";
import { WarningFilled, LoadingOutlined } from "@ant-design/icons";
import { apiContract } from "../../../../../api/api-contract";
import { CONTRACT_TYPE } from "../../../../../common/utils/static-data";
import { styles } from "../suggestion-styles";

const { Option } = AutoComplete;
const antIcon = <LoadingOutlined style={{ fontSize: 22 }} spin />;
const INFOMATION_DATA = [
  {
    id: 1,
    title: "Lái xe",
    feild: "driver_info",
    type: "AutoComplete",
    options: "optionsDriver",
  },
  {
    id: 4,
    title: "Biển kiểm soát",
    feild: "vehicle_info",
    type: "AutoComplete",
    options: "optionsVehicle",
  },
  {
    id: 2,
    title: "Loại xe",
    feild: "vehicle_info",
    feild_chil: "type",
    type: "Input",
  },
  {
    id: 6,
    title: "Số chỗ",
    feild: "vehicle_info",
    feild_chil: "number_seat",
    type: "Input",
  },
  {
    id: 3,
    title: "Màu sắc",
    feild: "vehicle_info",
    feild_chil: "color",
    type: "Input",
  },

  {
    id: 5,
    title: "Model",
    feild: "vehicle_info",
    feild_chil: "model",
    type: "Input",
  },
];

const VEHICLE_INFO_INIT = {
  color: "",
  contract_contained: {},
  id: null,
  model: "",
  number_plate: "",
  type: "",
};

const DRIVER_INFO_INIT = {
  contract_contained: null,
  email: "",
  id: null,
  id_card: "",
  name: "",
  mobile: "",
};

export class VehicleInfomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      required: false,
      vehicle_info: VEHICLE_INFO_INIT,
      driver_info: DRIVER_INFO_INIT,
      optionsDriver: [],
      optionsVehicle: [],
      isDisableUser: true,
      isLoadMore: false,

      // state for form
      parking_id: 2,
      driver_know_english: true,
    };

    this.timeout = null;
    this.currentValueVehicle = null;
    this.currentValueDriver = null;
    this.driverTotalPage = 1;
    this.vehicleTotalPage = 1;
    this.driverPage = 1;
    this.vehiclePage = 1;
  }

  onSearch = (feild, data, parentField) => {
    const { contract_type } = this.props;
    var self = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    if (feild === "optionsDriver") {
      this.currentValueDriver = data;
      this.driverPage = 1;
    } else {
      this.currentValueVehicle = data;
      this.vehiclePage = 1;
    }

    if (!data) {
      if (feild === "optionsVehicle") {
        this.setState({
          [feild]: [],
          vehicle_info: VEHICLE_INFO_INIT,
        });
      } else {
        this.setState({
          [feild]: [],
          driver_info: DRIVER_INFO_INIT,
        });
      }
      this.props.validateFields(["vehicle_info", "driver_info"]);
      return;
    }
    if (feild === "optionsVehicle") {
      this.setState({
        vehicle_info: VEHICLE_INFO_INIT,
      });
    } else {
      this.setState({
        driver_info: DRIVER_INFO_INIT,
      });
    }
    async function searchData() {
      let func = apiContract.driverSuggest;
      if (feild === "optionsDriver") {
        func = apiContract.driverSuggest;
        if (contract_type === CONTRACT_TYPE.without_driver) {
          func = apiContract.driverSuggestContractWithout;
        }
      } else {
        func = apiContract.vehiclesSuggest;
      }
      try {
        const result = await func(data.trim());
        if (result.status === "success") {
          if (feild === "optionsDriver") {
            if (self.currentValueDriver !== data) {
              return;
            }
            self.driverTotalPage = result.data.total_pages;
          } else {
            if (self.currentValueVehicle !== data) {
              return;
            }
            self.vehicleTotalPage = result.data.total_pages;
          }
          const minorSearch = result.data.content.find((suggestion) => {
            if (feild === "optionsDriver") {
              return suggestion.name.trim() === data.trim();
            } else {
              return suggestion.number_plate.trim() === data.trim();
            }
          });
          if (minorSearch) {
            const { contract_contained } = minorSearch;
            let broken_vehicle = false;
            if (feild !== "optionsDriver" && minorSearch.status === 0) {
              broken_vehicle = true;
            }
            if (!contract_contained && !broken_vehicle) {
              return self.setState(
                {
                  [parentField]: minorSearch,
                  [feild]: result.data.content.map((suggestion) => {
                    return {
                      ...suggestion,
                      value:
                        feild === "optionsDriver"
                          ? `${suggestion.name} - ${suggestion.id_card}`
                          : suggestion.number_plate,
                    };
                  }),
                },
                () => {
                  self.props.validateFields([parentField]);
                }
              );
            }
          }
          self.setState(
            {
              [feild]: result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value:
                    feild === "optionsDriver"
                      ? `${suggestion.name} - ${suggestion.id_card}`
                      : suggestion.number_plate,
                };
              }),
            },
            () => {
              self.props.validateFields([parentField]);
            }
          );
        }
      } catch (error) {}
    }

    this.timeout = setTimeout(searchData, 300);
  };

  loadMoreFunc = async (feild) => {
    const { contract_type } = this.props;
    let func = apiContract.driverSuggest;
    let page = 1;
    let data = "";
    if (feild === "optionsDriver") {
      func = apiContract.driverSuggest;
      if (contract_type === CONTRACT_TYPE.without_driver) {
        func = apiContract.driverSuggestContractWithout;
      }
      page = this.driverPage;
      data = this.currentValueDriver;
    } else {
      func = apiContract.vehiclesSuggest;
      page = this.vehiclePage;
      data = this.currentValueVehicle;
    }
    try {
      this.setState({ isLoadMore: true });
      const result = await func(data.trim(), page);

      if (result.status === "success") {
        if (feild === "optionsDriver") {
          this.driverTotalPage = result.data.total_pages;
        } else {
          this.vehicleTotalPage = result.data.total_pages;
        }

        this.setState(
          {
            [feild]: this.state[feild].concat(
              result.data.content.map((suggestion) => {
                return {
                  ...suggestion,
                  value:
                    feild === "optionsDriver"
                      ? `${suggestion.name} - ${suggestion.id_card}`
                      : suggestion.number_plate,
                };
              })
            ),
          },
          () => this.setState({ isLoadMore: false })
        );
      } else {
        this.setState({ isLoadMore: false });
      }
    } catch (error) {
      this.setState({ isLoadMore: false });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.vehicle_info !== this.state.vehicle_info) {
      if (
        this.state.vehicle_info &&
        this.state.vehicle_info.fuel_type_group_id
      ) {
        this.props.setFuelCodes(this.state.vehicle_info.fuel_type_group_id);
      } else {
        this.props.setFuelCodes(null);
      }
    }
  }

  onSelect = (feild, item) => {
    const { data } = item;

    this.setState({ [feild]: data }, () => {
      setTimeout(() => {
        this.props.validateFields([feild]);
      }, 100);
    });
    this.props.onChangeForm(
      feild,
      feild === "driver_info" ? data.name : data.number_plate
    );
  };

  suggestionRender = (data, feild) => {
    const { editPage, contract_type } = this.props;
    const oldVehicle = this.oldVehicle;
    const oldDriver = this.oldDriver;
    let loadMore = false;
    const IS_DRIVER = feild === "driver_info";
    if (IS_DRIVER) {
      loadMore = this.driverTotalPage > this.driverPage;
    } else {
      loadMore = this.vehicleTotalPage > this.vehiclePage;
    }

    const { isLoadMore } = this.state;
    return (
      <>
        {data.map((value, idx) => {
          const { contract_contained } = value;
          let in_journey = false;
          let is_lend = false;
          let broken_vehicle = false;
          let has_container_in_contract_without_driver = false;
          let vehicle_in_contract_different_type = false;
          let cardShow = "";
          let checkId = true;

          if (IS_DRIVER && value.id_card) {
            if (value.id_card.length > 4) {
              cardShow = `****${value.id_card.substring(
                value.id_card.length - 4,
                value.id_card.length
              )}`;
            } else {
              cardShow = value.id_card;
            }
          }

          if (value.id === this.state[feild].id) {
            checkId = false;
          }
          if (IS_DRIVER) {
            if (oldDriver) {
              if (value.id === oldDriver.id) {
                checkId = false;
              }
            }
          } else {
            if (oldVehicle) {
              if (value.id === oldVehicle.id) {
                checkId = false;
              }
            }

            // broken_vehicle = value.status == 0;
          }
          let text = "";
          broken_vehicle = value.status == 0;
          if (broken_vehicle) {
            text = `${
              !IS_DRIVER ? "Xe" : "Tài xế"
            } đang trong trạng thái không thể điều động`;
          } else {
            in_journey = value.in_journey;
            if (in_journey) {
              text = `${
                !IS_DRIVER ? "Xe" : "Tài xế"
              } đang thực hiện nhật ký hành trình`;
            } else {
              if (contract_contained) {
                if (contract_type === CONTRACT_TYPE.without_driver) {
                  has_container_in_contract_without_driver = true;
                }

                is_lend = contract_contained.is_lend;
                text = !IS_DRIVER
                  ? `Xe đang có trong hợp đồng ${contract_contained.code}`
                  : `Tài xế đang có trong hợp đồng ${contract_contained.code}`;
                if (is_lend) {
                  text = `${!IS_DRIVER ? "Xe" : "Tài xế"} đang cho hợp đồng ${
                    contract_contained.code
                  } mượn`;
                }

                if (
                  contract_contained.contract_type ===
                  CONTRACT_TYPE.without_driver
                ) {
                  vehicle_in_contract_different_type = true;
                }

                if (!IS_DRIVER) {
                  if (contract_contained.contract_type !== contract_type) {
                    text = `Xe đang có trong hợp đồng ${
                      contract_contained.contract_type ===
                      CONTRACT_TYPE.has_driver
                        ? "có lái"
                        : "không lái"
                    } ${contract_contained.code}`;
                  }
                }
              }
            }
          }

          return (
            <Option
              data={value}
              disabled={
                (in_journey ||
                  is_lend ||
                  vehicle_in_contract_different_type ||
                  has_container_in_contract_without_driver ||
                  broken_vehicle) &&
                checkId
              }
              style={styles.selectOptoption}
              key={value.id}
              value={value.value}
            >
              <div style={styles.container}>
                <div style={styles.mainTitle}>
                  {!IS_DRIVER
                    ? value.value
                    : contract_type !== "contract_without_driver"
                    ? `${value.name} - ${cardShow} - ${
                        value.country_code ? `(+${value.country_code})` : ""
                      }${value.mobile}`
                    : `${value.name} - ${
                        value.country_code ? `(+${value.country_code})` : ""
                      }${value.mobile}`}
                </div>
                {(contract_contained || broken_vehicle) &&
                  (editPage ? (
                    checkId ? (
                      <div style={styles.contract_contained}>
                        <WarningFilled style={styles.icon} />
                        {text}
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    <div style={styles.contract_contained}>
                      <WarningFilled style={styles.icon} />
                      {text}
                    </div>
                  ))}
              </div>
            </Option>
          );
        })}
        {data.length > 0 && loadMore && !isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div
              onClick={() => {
                let feildLoadMore = "";
                if (IS_DRIVER) {
                  feildLoadMore = "optionsDriver";
                  this.driverPage++;
                } else {
                  feildLoadMore = "optionsVehicle";
                  this.vehiclePage++;
                }
                this.loadMoreFunc(feildLoadMore);
              }}
              style={styles.loadmore}
            >
              Loadmore
            </div>
          </Option>
        )}
        {isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div style={styles.loadmoreLoading}>
              <Spin indicator={antIcon} />
            </div>
          </Option>
        )}
      </>
    );
  };

  changeCheckBox = (field, value) => {
    this.setState({ [field]: value }, () => {
      const { editPage, checkChangeFormValue } = this.props;
      if (editPage) {
        checkChangeFormValue();
      }
    });
  };

  render() {
    var self = this;
    const { parking_id, driver_know_english } = this.state;
    const { unlimitEdit, contract_type } = this.props;
    return (
      <>
        <div className="title-contract">4. Thông tin xe cho thuê*</div>
        {INFOMATION_DATA.map((value) => {
          if (value.feild_chil) {
            return (
              <Form.Item key={value.id} label={`+ ${value.title}::`}>
                <Input
                  disabled={true}
                  value={this.state[value.feild][value?.feild_chil]}
                  placeholder={value.title}
                />
              </Form.Item>
            );
          }
          return (
            <Form.Item
              key={value.id}
              //dependencies={value.feild === 'driver_info' ? ['vehicle_info'] : ['driver_info']}
              name={value.feild}
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, v) {
                    const { vehicle_info, driver_info, required } = self.state;
                    if (value.feild === "vehicle_info") {
                      const driverValue = getFieldValue("driver_info");
                      if (required) {
                        if (vehicle_info.id === null) {
                          return Promise.reject(`Bạn cần chọn một xe!`);
                        }
                      }
                      if (
                        vehicle_info.id === null &&
                        driver_info.id === null &&
                        !v &&
                        !driverValue
                      ) {
                        return Promise.resolve();
                      }
                      if (!v && !driverValue) {
                        return Promise.resolve();
                      }
                      if (vehicle_info.id === null && v) {
                        return Promise.reject(`Bạn cần chọn một xe!`);
                      }
                      if (
                        v &&
                        (v === vehicle_info.number_plate ||
                          driverValue === driver_info.name)
                      ) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(`Bạn cần chọn một xe!`);
                      }
                    } else {
                      const vehicleValue = getFieldValue("vehicle_info");
                      if (required) {
                        if (driver_info.id === null) {
                          return Promise.reject(`Bạn cần chọn tài xế!`);
                        }
                      }
                      if (
                        vehicle_info.id === null &&
                        driver_info.id === null &&
                        !v &&
                        !vehicleValue
                      ) {
                        return Promise.resolve();
                      }

                      if (!v && !vehicleValue) {
                        return Promise.resolve();
                      }

                      if (driver_info.id === null && v) {
                        return Promise.reject(`Bạn cần chọn tài xế!`);
                      }
                      if (
                        v &&
                        (v === driver_info.name ||
                          vehicleValue === vehicle_info.number_plate)
                      ) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(`Bạn cần chọn một tài xế!`);
                      }
                    }
                  },
                }),
              ]}
              label={`+ ${value.title}::`}
            >
              <AutoComplete
                disabled={!unlimitEdit}
                getPopupContainer={(node) => {
                  if (node) {
                    return node.parentNode;
                  }
                  return document.body;
                }}
                onSearch={(data) =>
                  this.onSearch(value?.options, data, value.feild)
                }
                placeholder={value.title}
                onSelect={(data, option) => this.onSelect(value.feild, option)}
              >
                {this.suggestionRender(this.state[value?.options], value.feild)}
              </AutoComplete>
            </Form.Item>
          );
        })}
        {contract_type === CONTRACT_TYPE.has_driver && (
          <>
            <Form.Item
              wrapperCol={15}
              label={
                <div className="label-special">
                  <div className="plus">+</div>
                  <div>Bãi đỗ xe:</div>
                </div>
              }
              className="lableEmptyKm"
            >
              <div className="vat-fee">
                <Checkbox
                  className="special-checkbox"
                  disabled={!unlimitEdit}
                  onChange={() => this.changeCheckBox("parking_id", 2)}
                  checked={parking_id === 2}
                >
                  Avis
                </Checkbox>
                <Checkbox
                  disabled={!unlimitEdit}
                  onChange={() => this.changeCheckBox("parking_id", 1)}
                  checked={parking_id === 1}
                >
                  Khách hàng
                </Checkbox>
              </div>
            </Form.Item>

            <Form.Item
              wrapperCol={15}
              label={
                <div className="label-special">
                  <div className="plus">+</div>
                  <div>Tài có tiếng anh:</div>
                </div>
              }
              className="lableEmptyKm"
            >
              <div className="vat-fee">
                <Checkbox
                  disabled={!unlimitEdit}
                  onChange={() =>
                    this.changeCheckBox("driver_know_english", true)
                  }
                  checked={driver_know_english}
                >
                  Có{" "}
                </Checkbox>
                <Checkbox
                  className="special-checkbox"
                  disabled={!unlimitEdit}
                  onChange={() =>
                    this.changeCheckBox("driver_know_english", false)
                  }
                  checked={!driver_know_english}
                >
                  Không
                </Checkbox>
              </div>
            </Form.Item>
          </>
        )}
      </>
    );
  }
}
